import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { auctionsApi, type RegistrationListParams } from '../api/auctions-api';

import { auctionKeys } from './auction-keys';

export function registrationListQueryOptions(storeId: string, params: RegistrationListParams) {
  return queryOptions({
    queryKey: auctionKeys.registrationList(storeId, params),
    queryFn: () => auctionsApi.registrations(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useAuctionRegistrations(storeId: string, params: RegistrationListParams) {
  return useQuery(registrationListQueryOptions(storeId, params));
}
